var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-table',{attrs:{"url":"/api/v1/userReport","filter":[
      {
        name: 'with',
        value: [
          'moderator',
          'customerProfile',
          'customerProfile.user',
          'fakeProfile',
          'moderator.user'
        ]
      }
    ],"attributes":[
      {
        name: 'Name',
        attribute: 'customer_profile',
        type: 'LinkProfileCell',
        sortable: false
      },
      {
        attribute: 'moderator.user',
        name: 'Moderator',
        type: 'UserCell',
        sortable: false
      },
      {
        name: 'Dialog',
        type: 'DialogLink'
      },
      {
        attribute: 'accusation',
        name: 'Anschuldigung'
      },
      {
        attribute: 'created_at',
        name: 'Datum',
        type: 'DateTimeCell'
      },
      {
        attribute: 'disabled',
        name: 'Dialog sperren',
        type: 'ToggleCell',
        url: 'toggle_disable_url',
        sortable: false
      },
      {
        attribute: 'completed',
        name: 'Fall abgearbeitet',
        type: 'ToggleCell',
        url: 'toggle_completed_url'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }